import { BaseGlobalConfigurationsUrl, BaseGlobalOperationsUrl, BaseGlobalMonitoringUrl, BaseGlobalPassengerAppUrl } from '@/menus/__base';
import { ConfigurationMenu, OperationMenu, MonitoringMenu, PassengerAppMenu } from '@/menus/global';

export const useGetGlobalMenu = () => {
  let pathname = window.location.pathname;
  if (pathname.startsWith(BaseGlobalConfigurationsUrl)) {
    return ConfigurationMenu;
  } else if (pathname.startsWith(BaseGlobalOperationsUrl)) {
    return OperationMenu;
  } else if (pathname.startsWith(BaseGlobalMonitoringUrl)) {
    return MonitoringMenu;
  } else if (pathname.startsWith(BaseGlobalPassengerAppUrl)) {
    return PassengerAppMenu;
  }
  return [];
};
